import { useState } from "react";
import apiParticipantes from "../api/Participantes/api-participantes";
import apiMaestras from "../api/Maestras/api-maestras";

export const useAsignarHojasdeVida = () => {
  const [todosJurados, setTodosJurados] = useState<any[]>([]);
  const [datosFiltro, setDatosFiltro] = useState<any[]>([]);
  const [totalRegistros, setTotalRegistros] = useState<number>(0);
  const [cantidadPáginas, setCantidadPáginas] = useState<number>(10);
  const [loading, setLoading] = useState(false);
  const [areas, setAreas] = useState<any[]>([]);
  const [categorias, setCategorias] = useState<any[]>([]);
  const [modalAsignarJurados, setModalAsignarJurados] = useState(false);
  const [juradosSeleccionados, setJuradosSeleccionados] = useState<any[]>([]);

  const [filtros, setFiltros] = useState<any>({
    buscarpalabra: "",
    area: null,
    categoria: null,
    estado: "",
  });

  // Extrae el array de la respuesta API de forma segura
  const extractArray = (res: any): any[] => {
    if (Array.isArray(res)) return res;
    if (!res) return [];
    if (Array.isArray(res.postulacionesJurados)) return res.postulacionesJurados;
    if (Array.isArray(res.data)) return res.data;
    const firstArrayKey = Object.keys(res).find((k) => Array.isArray(res[k]));
    return firstArrayKey ? res[firstArrayKey] : [];
  };

  const cargarJurados = async () => {
    setLoading(true);
    try {
      const res = await apiParticipantes.consultarPostulacionesJurados();
      const lista = extractArray(res);

      // Jurados en estado "Aceptó" o "Por evaluar"
      const juradosAceptados = lista
        .filter((x: any) =>
          x.estado === "Aceptó" || x.status === "Aceptó" ||
          x.estado === "Por evaluar" || x.status === "Por evaluar"
        )
        .map((x: any) => ({ ...x, checked: false }));

      setTodosJurados(juradosAceptados);
      setDatosFiltro(juradosAceptados);
      setTotalRegistros(juradosAceptados.length);
    } catch (error) {
      console.error("Error al cargar jurados:", error);
    } finally {
      setLoading(false);
    }
  };

  const obtenerAreas = async () => {
    try {
      const data: any = await apiMaestras.obtenerAreasConCategorias();
      // La respuesta tiene forma: { ok: true, areas: [...] }
      let lista: any[];
      if (Array.isArray(data?.areas)) { lista = data.areas; }
      else if (Array.isArray(data)) { lista = data; }
      else { lista = []; }
      setAreas(lista);
    } catch (error) {
      console.error("Error al obtener áreas:", error);
    }
  };

  // Al cambiar área, extrae las categorías desde los datos ya cargados
  const handleAreaChange = (id_area: any) => {
    setFiltros((prev: any) => ({ ...prev, area: id_area, categoria: null }));
    setCategorias([]);

    // Estructura: { id_area, nombre_area, categorias_areas: [{id, nombre}] }
    const areaData = areas.find((a: any) => a.id_area === id_area);
    if (areaData && Array.isArray(areaData.categorias_areas)) {
      setCategorias(areaData.categorias_areas);
    }
  };

  const buscarJurados = () => {
    let filtro = [...todosJurados];

    // Filtro por palabra clave (documento o código radicado)
    if (filtros.buscarpalabra && filtros.buscarpalabra.trim() !== "") {
      const palabra = filtros.buscarpalabra.trim().toUpperCase();
      filtro = filtro.filter((x: any) => {
        const documento = String(x.numero_documento_participante ?? x.numero_documento ?? "").toUpperCase();
        const radicado = (x.radicado ?? "").toUpperCase();
        return documento.includes(palabra) || radicado.includes(palabra);
      });
    }

    // Filtro por área: compara nombre_area del área seleccionada contra x.area
    if (filtros.area) {
      const areaSeleccionada = areas.find((a: any) => a.id_area === filtros.area);
      const areaNombre = (areaSeleccionada?.nombre_area ?? "").toUpperCase();
      if (areaNombre) {
        filtro = filtro.filter((x: any) =>
          (x.area ?? "").toUpperCase() === areaNombre
        );
      }
    }

    // Filtro por categoría: categorias_area es array de objetos {id, nombre, checked}
    if (filtros.categoria) {
      filtro = filtro.filter((x: any) => {
        if (!Array.isArray(x.categorias_area)) return false;
        return x.categorias_area.some((c: any) => c.id === filtros.categoria);
      });
    }

    console.log("filtro", filtro);
    setDatosFiltro(filtro.map((x: any) => ({ ...x, checked: false })));
    setTotalRegistros(filtro.length);
    setJuradosSeleccionados([]);
  };

  const limpiarFiltros = () => {
    setFiltros({ buscarpalabra: "", area: null, categoria: null, estado: "" });
    setCategorias([]);
    const reset = todosJurados.map((x: any) => ({ ...x, checked: false }));
    setDatosFiltro(reset);
    setTotalRegistros(reset.length);
    setJuradosSeleccionados([]);
  };

  const cambiarCantidadPaginas = (_e: any, value: any) => {
    setCantidadPáginas(Number(value));
  };

  // Seleccionar / deseleccionar una fila individual
  const cambiarCheckbox = (datos: any) => {
    let infoupdate = datosFiltro.map((data: any) => {
      if (data.id_postulacion === datos.id_postulacion) {
        return {
          ...data,
          checked: !data.checked,
        };
      }
      return {
        ...data,
      };
    });

    let juradosSeleccionadosUpdate = infoupdate.filter((x) => x.checked);
    let idsProyectos = juradosSeleccionadosUpdate.map((x: any) => {
      return {
        id_postulacion: x.id_postulacion,
      };
    });

    localStorage.setItem("proyectosAsignados", JSON.stringify(idsProyectos));
    setJuradosSeleccionados(juradosSeleccionadosUpdate);

    return setDatosFiltro(infoupdate);
  };

  // Seleccionar / deseleccionar todos
  const toggleSeleccionarTodos = () => {
    const todosChecked = datosFiltro.every((x: any) => x.checked);
    const updated = datosFiltro.map((x: any) => ({
      ...x,
      checked: !todosChecked,
    }));

    let juradosSeleccionadosUpdate = updated.filter((x: any) => x.checked);
    let idsProyectos = juradosSeleccionadosUpdate.map((x: any) => ({
      id_postulacion: x.id_postulacion,
    }));

    localStorage.setItem("proyectosAsignados", JSON.stringify(idsProyectos));
    setJuradosSeleccionados(juradosSeleccionadosUpdate);
    setDatosFiltro(updated);
  };

  return {
    datosFiltro,
    setDatosFiltro,
    totalregistros: totalRegistros,
    cantidadpáginas: cantidadPáginas,
    loading,
    areas,
    categorias,
    setCategorias,
    filtros,
    setFiltros,
    cargarJurados,
    obtenerAreas,
    handleAreaChange,
    buscarJurados,
    limpiarFiltros,
    cambiarCantidadPaginas,
    cambiarCheckbox,
    toggleSeleccionarTodos,
    juradosSeleccionados,
    modalasignarjurados: modalAsignarJurados,
    setModalAsignarJurados,
  };
};
